import { ReactElement, useContext } from "react";

import { Factor } from "types/factor/factor";

import RemoveFactorContext from "../../contexts/RemoveFactorContext";

import FactorIcon from "./factorIcon/factorIcon";
import HeaderContent from "./headerContent/HeaderContent";
import HeaderButton from "./headerButton/HeaderButton";

import styles from "./factor-header.module.css";

const FactorHeader = ({
  factor,
  isSetUpOpen,
  onClickSetup,
}: {
  factor: Factor;
  isSetUpOpen: boolean;
  onClickSetup: () => void;
}): ReactElement => {
  const { isRemoveEnabled } = useContext(RemoveFactorContext);

  const showSetUpButton = !factor.flags.isActive && !isSetUpOpen;
  const showRemoveButton = factor.flags.isActive && isRemoveEnabled;

  return (
    <div className={styles.factorHeader}>
      <div className={styles.noFlex}>
        <FactorIcon factorKey={factor.key} />
      </div>

      <div className={styles.content}>
        <HeaderContent factor={factor} />
      </div>

      {(showSetUpButton || showRemoveButton) && (
        <div className={`${styles.noFlex} ${styles.buttonContainer}`}>
          <HeaderButton
            factor={factor}
            showSetUpButton={showSetUpButton}
            showRemoveButton={showRemoveButton}
            onClickSetup={onClickSetup}
          />
        </div>
      )}
    </div>
  );
};

export default FactorHeader;
